import { render, staticRenderFns } from "./Responsavel.vue?vue&type=template&id=4057fdf1&"
import script from "./Responsavel.vue?vue&type=script&lang=js&"
export * from "./Responsavel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports